<template>
  <Layout>
    

    <div class="row">
      <div class="col-lg-12">
        <div class="card border border-radius-12">
          <PageHeader :title="title" class="poppins fw-normal ps-3 pt-3" />
          <div class="card-body table">
            
            <div class="main_header_ctas d-flex gap-2 flex-wrap align-items-center justify-content-between py-2">
              <div :class="{'del_btn-wrapper':true, 'rounded-pill border-orange p1': multipuleIds.length >= 1}">

<button
  v-if="multipuleIds.length >= 1"
  @click="deleteBulk"
  class="
    btn
    border-0
    px-5
    fw-bold
    text-white
    btn btn-primary
    waves-effect waves-light
    w-md
    primary-button
    rounded-pill
  "
>
  Delete All
</button>
</div>
            <div class="add_new rounded-pill border-orange p1" >  <router-link to="/feature/add"
           class="
             btn
             btn-primary
             border-0
             px-5
             fw-bold
             text-white
             btn btn-primary
             waves-effect waves-light
             w-md
             primary-button
             rounded-pill
           "
         >
           Add New Feature
            </router-link></div>
         </div>
            <div class="table-responsive">
              <table
                id="datatable"
                class="table table-centered table-nowrap mb-0"
              >
                <thead class="table-light">
                  <tr>
                    <th style="width: 20px">
                      <div class="form-check font-size-16">
                        <input
                          @change="selectAllRecord"
                          v-model="selectAll"
                          type="checkbox"
                          class="form-check-input"
                          id="customCheck1"
                        />
                        <label class="form-check-label" for="customCheck1"
                          >&nbsp;</label
                        >
                      </div>
                    </th>
                    <th>Feature Title</th>
                    <th>Feature Icon</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr colspan="3" v-if="loading">
                    <td colspan="4">
                      <APILoader
                        :loading="loading"
                        class="align-middle text-center"
                      ></APILoader>
                    </td>
                  </tr>
                  <tr v-else v-for="(feature, index) in features" :key="index">
                    <th style="width: 20px">
                      <div class="form-check font-size-16">
                        <input
                          v-model="multipuleIds"
                          :value="feature.id"
                          type="checkbox"
                          class="form-check-input"
                          id="customCheck1"
                        />
                        <label class="form-check-label" for="customCheck1"
                          >&nbsp;</label
                        >
                      </div>
                    </th>
                    <td>
                      <span>{{ feature.feature }}</span>
                    </td>
                    <td>
                      <img v-if="feature.image" :src="feature.image" alt="Not Exist" height="50px" width="50px"/>
                      <span v-else>N/A</span>
                    </td>

                    <td>
                      <div class="d-flex">
                        <button
                          style="margin: 10px"
                          @click="updateCategory(feature.id)"
                          class="p-0 bg-transparent border-0"
                        >
                          <span class="text-primary">
                            <i class="uil-edit"></i>
                          </span>
                        </button>
                        <button
                          @click="deleteFeature(feature.id)"
                          class="p-0 bg-transparent border-0"
                        >
                          <span class="text-danger">
                            <i class="uil-trash-alt"></i>
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- end table-responsive -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
  <script>
import Layout from "../../../layouts/static/main";
import PageHeader from "@/components/static/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import $ from "jquery";
export default {
  page: {
    meta: [
      {
        name: "add-user",
        content: appConfig.description,
      },
    ],
  },
  name: "category",
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      multipuleIds: [],
      selectAll: false,
      title: "Feature Listing",
      loading: true,
      features: null,
    };
  },
  mounted() {
    this.allFeature();
  },
  methods: {
    randerData(response) {
      this.features = response.data.data;
      this.loading = false;
      if ($.fn.dataTable.isDataTable("#datatable")) {
        let table = $("#datatable").DataTable();
        table.destroy();
      }
      setTimeout(() => {
        $("#datatable").DataTable({
          ordering: false,
          lengthMenu: [
            [5, 10, 25, 50, -1],
            [5, 10, 25, 50, "All"],
          ],
          pageLength: 25,
        });
      });
    },
    allFeature() {
      this.$axios
        .get("feature")
        .then((response) => {
          setInterval(this.randerData(response), 1500);
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    updateCategory: function (id) {
      this.$router.push({
        name: "update-feature",
        params: { id: id },
      });
    },
    async delete(id) {
      try {
        const {
          data: { status },
        } = await this.$axios.delete("feature/" + id);
        this.responseDelete = status;
      } catch (error) {
        console.log(error);
      }
    },
    deleteFeature(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.delete(id);
          let status = this.responseDelete;
          if (status == true) {
            Swal.fire("Deleted!", "Record has been deleted.", "success");
            this.allFeature();
          }
        }
      });
    },
    selectAllRecord() {
      if (this.selectAll) {
        let ids = [];
        this.features.forEach((element) => {
          ids.push(element.id);
        });
        this.multipuleIds = [...new Set(ids)];
        console.log(this.multipuleIds);
      } else {
        this.multipuleIds = [];
        console.log(this.multipuleIds);
      }
    },
    deleteBulk() {
      console.log(this.multipuleIds);
      this.$axios
        .post("delete-feature-bulk", { ids: this.multipuleIds })
        .then((response) => {
          this.allFeature();
          this.triggerSwal(response.data.message.message, "success");
          this.selectAll = false;
          this.multipuleIds = [];
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
  },
};
</script>
  